function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Error, Button } from 'module-tsl-ui-elements';
import { Collapsible } from 'module-tsl-ui-collapsible';
import { injectStripe } from 'react-stripe-elements';
import CreditCardEntry from './CreditCardEntry';
import { countryCode, amount, price as priceType } from './types';
import DiscountCode from './DiscountCode';
import MultiTeacherLicence from './MultiTeacherLicence';

var formatAmount = function formatAmount(_ref) {
  var currencySymbol = _ref.symbol,
      priceAmount = _ref.amount,
      code = _ref.code;
  var fixedAmount = priceAmount.toFixed(2);
  if (code === 'AUD' || code === 'CAD' || code === 'NZD') return "$".concat(fixedAmount, " ").concat(code);
  return "".concat(currencySymbol).concat(fixedAmount);
};

var PaymentForm = /*#__PURE__*/function (_Component) {
  _inherits(PaymentForm, _Component);

  var _super = _createSuper(PaymentForm);

  function PaymentForm() {
    var _this;

    _classCallCheck(this, PaymentForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onPay", function () {
      if (_this.props.featureStripe) {
        var _this$props$safeField = _this.props.safeFields,
            name = _this$props$safeField.name,
            email = _this$props$safeField.email;

        _this.props.submitPaymentToStripe({
          createPaymentMethod: _this.props.stripe.createPaymentMethod,
          handleCardAction: _this.props.stripe.handleCardAction,
          type: 'card',
          paymentData: {
            billing_details: {
              name: name,
              email: email
            }
          }
        });
      } else {
        _this.props.pay();
      }

      _this.props.setSubmitted();
    });

    return _this;
  }

  _createClass(PaymentForm, [{
    key: "onChange",
    value: function onChange(field) {
      var _this2 = this;

      return function (e) {
        var updates = {};
        updates[field] = e.target.value;

        _this2.props.setSafeFields(updates);
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          balanceBefore = _this$props.balanceBefore,
          balanceAfter = _this$props.balanceAfter,
          price = _this$props.price,
          cardCharge = _this$props.cardCharge,
          paymentError = _this$props.paymentError,
          countryCodes = _this$props.countryCodes,
          safeFields = _this$props.safeFields,
          safeFieldsValidation = _this$props.safeFieldsValidation,
          singlePrice = _this$props.singlePrice,
          schoolLicPrice = _this$props.schoolLicPrice,
          mtl_multiplier = _this$props.mtl_multiplier,
          setMultiTeacherLicence = _this$props.setMultiTeacherLicence,
          multiTeachingLicCheckboxId = _this$props.multiTeachingLicCheckboxId,
          isMultiTeacherLicence = _this$props.isMultiTeacherLicence,
          loadCountryCodes = _this$props.loadCountryCodes,
          setSafeFields = _this$props.setSafeFields,
          successMessage = _this$props.successMessage;
      var involvesCredit = false;

      if (!this.props.isForex && (price.offerId || balanceBefore.amount)) {
        involvesCredit = true;
      }

      var buttonLabel = 'Get Resource';

      if (!this.props.isBalanceOnly) {
        buttonLabel = "Pay ".concat(formatAmount(cardCharge));
      }

      if (this.props.buttonDisabled || this.props.checkoutLoading) {
        buttonLabel = /*#__PURE__*/React.createElement("i", {
          className: "tes-btn__icon icon icon-loading-spinner icon-spin"
        });
      }

      var storedCardAndSubmit = /*#__PURE__*/React.createElement("div", {
        className: "payment-cta__container"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: this.onPay,
        className: "payment-cta__btn",
        size: "xl",
        isBlock: true,
        disabled: this.props.buttonDisabled || this.props.checkoutLoading,
        loading: this.props.isStripeLoading
      }, buttonLabel));
      var discountCode = /*#__PURE__*/React.createElement(DiscountCode, {
        discountCode: this.props.discountCode,
        showDiscountCodeInput: this.props.showDiscountCodeInput,
        setDiscountCode: this.props.setDiscountCode,
        discountCodeError: this.props.discountCodeError,
        reloadCheckout: this.props.reloadCheckout,
        setInputFocus: this.props.setInputFocus,
        inputFocused: this.props.inputFocused,
        checkoutLoading: this.props.checkoutLoading,
        discountCodeApplied: this.props.discountCodeApplied,
        clearDiscountCode: this.props.clearDiscountCode,
        isPostalCodeNeeded: this.props.isPostalCodeNeeded,
        isEmailConfirmationNeeded: this.props.isEmailConfirmationNeeded
      });
      var ccEntry = /*#__PURE__*/React.createElement(CreditCardEntry, {
        isBalanceOnly: cardCharge.amount === 0,
        paymentError: paymentError,
        submitted: this.props.submitted,
        countryCodes: countryCodes,
        safeFields: safeFields,
        safeFieldsValidation: safeFieldsValidation,
        loadCountryCodes: loadCountryCodes,
        setSafeFields: setSafeFields,
        featureStripe: this.props.featureStripe,
        hasStoredCard: this.props.hasStoredCard,
        storedCard: this.props.storedCard,
        clearStoredCard: this.props.clearStoredCard
      });
      var bonusRow = null;
      var creditsRow = null;

      if (price.offerId) {
        creditsRow = /*#__PURE__*/React.createElement("li", {
          className: "purchase-summary__item creditsRow"
        }, /*#__PURE__*/React.createElement("span", {
          className: "purchase-summary__property"
        }, "Top-up credit"), /*#__PURE__*/React.createElement("span", {
          className: "purchase-summary__value plus"
        }, formatAmount(price)));

        if (price.offerBonus) {
          bonusRow = /*#__PURE__*/React.createElement("li", {
            className: "purchase-summary__item bonusRow"
          }, /*#__PURE__*/React.createElement("span", {
            className: "purchase-summary__property"
          }, "FREE credit"), /*#__PURE__*/React.createElement("span", {
            className: "purchase-summary__value plus"
          }, price.symbol + price.offerBonus.toFixed(2)));
        }
      }

      var itemsRows = null;
      itemsRows = this.props.items.map(function (item) {
        var itemResourcePrice = item.price;
        var itemDiscount = null;
        var itemAmount = formatAmount(itemResourcePrice);
        var involvesWarning = item.warnings && item.warnings.discountCode;

        if (itemResourcePrice.discountPercentage) {
          itemDiscount = /*#__PURE__*/React.createElement("span", {
            className: "line-through"
          }, itemResourcePrice.symbol + itemResourcePrice.originalPrice);
        }

        var itemWarning = null;

        if (involvesWarning) {
          itemWarning = item.warnings.discountCode;
        }

        return /*#__PURE__*/React.createElement("div", {
          className: "itemRow"
        }, /*#__PURE__*/React.createElement("li", {
          className: "purchase-summary__item"
        }, /*#__PURE__*/React.createElement("span", {
          className: "purchase-summary__property"
        }, "Item"), /*#__PURE__*/React.createElement("span", {
          className: "purchase-summary__value"
        }, item.description, involvesWarning && /*#__PURE__*/React.createElement("p", {
          className: "text text--sm text--red mb-0"
        }, itemWarning))), creditsRow, bonusRow, involvesCredit && /*#__PURE__*/React.createElement("li", {
          className: "purchase-summary__item"
        }, /*#__PURE__*/React.createElement("span", {
          className: "purchase-summary__property"
        }, "Item price"), /*#__PURE__*/React.createElement("span", {
          className: "purchase-summary__value minus"
        }, itemAmount)), !involvesCredit && /*#__PURE__*/React.createElement("li", {
          className: "purchase-summary__item"
        }, /*#__PURE__*/React.createElement("span", {
          className: "purchase-summary__property"
        }, "Card payment"), /*#__PURE__*/React.createElement("span", {
          className: "purchase-summary__value"
        }, itemDiscount, itemAmount)));
      });
      var helpEmail = 'help@tes.com';
      var licenceSpelling = 'licence';
      var helpFooter = /*#__PURE__*/React.createElement("small", null, /*#__PURE__*/React.createElement("span", {
        className: "modal-footer__title"
      }, 'Need help?'), ' Email ', /*#__PURE__*/React.createElement("a", {
        className: "link link--colored",
        href: "mailto:".concat(helpEmail)
      }, helpEmail), ' or call ', /*#__PURE__*/React.createElement("span", null, this.props.geoCountry === 'GB' ? '0345 5217111' : '+44 (0)20 3194 3164'));

      if (this.props.siteCountry === 'US') {
        licenceSpelling = 'license';
        helpFooter = /*#__PURE__*/React.createElement("small", null, /*#__PURE__*/React.createElement("span", {
          className: "modal-footer__title"
        }, "Need help?"), ' ', /*#__PURE__*/React.createElement("a", {
          className: "link link--colored",
          href: "http://www.tes.com/us/teacher-lessons/faq#js-q12-8",
          target: "_blank",
          rel: "noopener noreferrer"
        }, "Visit our FAQs"), ' or email ', /*#__PURE__*/React.createElement("a", {
          className: "link link--colored",
          href: "mailto:".concat(helpEmail)
        }, helpEmail));
      }

      var forexBalanceWarningToggler = /*#__PURE__*/React.createElement("span", {
        className: "l-flex-vcenter-spaced link"
      }, /*#__PURE__*/React.createElement("span", {
        className: "text text--discreet text--sm icon-text-container"
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon icon-info icon-sm icon-green"
      }), "Why can't I use my ".concat(formatAmount(balanceBefore), " balance?")), /*#__PURE__*/React.createElement("i", {
        className: "balance-info__icon icon icon-chevron-down icon-gray icon-sm"
      }));
      var forexBalanceWarning = null;

      if (this.props.isForex && balanceBefore.amount > 0) {
        forexBalanceWarning = /*#__PURE__*/React.createElement("div", {
          className: "mb-2 px-2"
        }, /*#__PURE__*/React.createElement(Collapsible, {
          toggler: forexBalanceWarningToggler
        }, /*#__PURE__*/React.createElement("div", {
          className: "balance-info"
        }, "You cannot use your balance for purchases of resources that have an original price in a foreign currency, as this one does.")));
      }

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "payment-modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "masthead__logo-link"
      }, /*#__PURE__*/React.createElement("img", {
        className: "masthead__logo-marker",
        src: "https://www.tes.com/logo.svg?variation=marker-white",
        width: "25",
        height: "24",
        alt: "Tes. For teaching."
      }), /*#__PURE__*/React.createElement("img", {
        className: "masthead__logo-text masthead__logo-text",
        src: "https://www.tes.com/logo.svg?theme=text",
        width: "39",
        height: "24",
        alt: "Tes. For teaching."
      })), /*#__PURE__*/React.createElement("p", {
        className: "text text--white mb-0 l-flex-vcenter"
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon icon-tds-locked icon-white icon--unit-md"
      }), /*#__PURE__*/React.createElement("span", null, "Checkout"))), /*#__PURE__*/React.createElement("div", {
        className: "payment-modal-container"
      }, ccEntry, /*#__PURE__*/React.createElement("div", {
        className: "modal-body with-footer"
      }, /*#__PURE__*/React.createElement("h3", {
        className: "heading heading--md mb-2 padding-top-ml"
      }, "Purchase Summary"), successMessage && /*#__PURE__*/React.createElement("div", null, successMessage), paymentError && /*#__PURE__*/React.createElement("div", {
        className: "mb-2"
      }, /*#__PURE__*/React.createElement(Error, {
        error: "We were unable to complete your purchase."
      })), /*#__PURE__*/React.createElement("ul", {
        className: "purchase-summary"
      }, itemsRows, involvesCredit && /*#__PURE__*/React.createElement("li", {
        className: "purchase-summary__item"
      }, /*#__PURE__*/React.createElement("span", {
        className: "purchase-summary__property remBalance"
      }, "Remaining credit"), /*#__PURE__*/React.createElement("span", {
        className: "purchase-summary__value remBalanceValue"
      }, formatAmount(balanceAfter))), /*#__PURE__*/React.createElement("li", {
        className: "purchase-summary__item purchase-summary__item--prominent"
      }, /*#__PURE__*/React.createElement("span", {
        className: "purchase-summary__property purchase-summary__property--prominent toPay"
      }, "To pay"), /*#__PURE__*/React.createElement("span", {
        className: "purchase-summary__value purchase-summary__value--prominent toPayValue"
      }, formatAmount(cardCharge)))), /*#__PURE__*/React.createElement(MultiTeacherLicence, {
        singlePrice: singlePrice,
        schoolLicPrice: schoolLicPrice,
        mtl_multiplier: mtl_multiplier // eslint-disable-line camelcase
        ,
        setMultiTeacherLicence: setMultiTeacherLicence,
        multiTeachingLicCheckboxId: multiTeachingLicCheckboxId,
        isMultiTeacherLicence: isMultiTeacherLicence
      }), !ccEntry, discountCode, forexBalanceWarning, /*#__PURE__*/React.createElement("div", {
        className: "guarantee"
      }, /*#__PURE__*/React.createElement("div", {
        className: "guarantee-info"
      }, "By clicking ", /*#__PURE__*/React.createElement("i", null, "Pay"), " your resource will download automatically, waiving your rights to a 14-day cooling off period. However, if the resource is technically faulty or mis-sold in the description, you may be eligible for a refund if you let us know within 48 hours. Please read our ", /*#__PURE__*/React.createElement("a", {
        href: "https://www.tes.com/help/resources-faq",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "FAQs"), " to find out more.")), /*#__PURE__*/React.createElement("p", {
        className: "text text--xs text--discreet mb-3 padding-right-md padding-left-md visible-xs"
      }, /*#__PURE__*/React.createElement("span", {
        className: "icon-text-container"
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon icon-download icon-sm icon-green"
      }), "You can download this resource at any time from your Tes dashboard")), /*#__PURE__*/React.createElement("p", {
        className: "text text--xs text--discreet mb-2"
      }, "By placing your order, you accept Tes Global Limited\u2019s", ' ', /*#__PURE__*/React.createElement("a", {
        className: "link link--colored",
        href: "//www.tes.com/terms-conditions/privacy-policy",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "privacy policy"), ", and the", ' ', /*#__PURE__*/React.createElement("a", {
        className: "link link--colored",
        href: "//www.tes.com/terms-conditions/terms-and-conditions",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "terms and conditions"), ",", ' ', /*#__PURE__*/React.createElement("a", {
        className: "link link--colored",
        href: "//www.tes.com/terms-conditions/additional-terms-tes-resources-and-tes-teach-formerl",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "refund policy"), ", and", ' ', /*#__PURE__*/React.createElement("a", {
        className: "link link--colored",
        href: "//www.tes.com/terms-conditions/summary-teaching-resources-licence",
        target: "_blank",
        rel: "noopener noreferrer"
      }, licenceSpelling), " for this resource."), this.props.paymentInProgressError ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
        className: "tds-form__error"
      }, "Due to an error, this resource is currently not accessible.", /*#__PURE__*/React.createElement("br", null), "Your order has been processed and you will be able to access this resource within the next 30 minutes.")) : storedCardAndSubmit, /*#__PURE__*/React.createElement("div", {
        className: "modal-footer"
      }, helpFooter))));
    }
  }]);

  return PaymentForm;
}(Component);

PaymentForm.displayName = "PaymentForm";
export default injectStripe(PaymentForm);
PaymentForm.propTypes = {
  balanceAfter: amount.isRequired,
  balanceBefore: amount.isRequired,
  buttonDisabled: PropTypes.bool.isRequired,
  cardCharge: amount.isRequired,
  siteCountry: PropTypes.string.isRequired,
  geoCountry: PropTypes.string.isRequired,
  isBalanceOnly: PropTypes.bool.isRequired,
  isForex: PropTypes.bool.isRequired,
  paymentError: PropTypes.object,
  paymentInProgressError: PropTypes.bool,
  price: priceType.isRequired,
  submitted: PropTypes.bool.isRequired,
  discountCode: PropTypes.string.isRequired,
  discountCodeError: PropTypes.string,
  inputFocused: PropTypes.bool.isRequired,
  checkoutLoading: PropTypes.bool.isRequired,
  discountCodeApplied: PropTypes.bool.isRequired,
  isPostalCodeNeeded: PropTypes.bool.isRequired,
  isEmailConfirmationNeeded: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    description: PropTypes.string.isRequired,
    price: priceType.isRequired,
    owns: PropTypes.bool.isRequired,
    warnings: PropTypes.object
  })).isRequired,
  safeFields: PropTypes.object,
  safeFieldsValidation: PropTypes.object.isRequired,
  countryCodes: PropTypes.arrayOf(countryCode).isRequired,
  singlePrice: priceType,
  schoolLicPrice: priceType,
  mtl_multiplier: PropTypes.number.isRequired,
  multiTeachingLicCheckboxId: PropTypes.string.isRequired,
  isMultiTeacherLicence: PropTypes.bool.isRequired,
  pay: PropTypes.func.isRequired,
  setMultiTeacherLicence: PropTypes.func.isRequired,
  setSafeFields: PropTypes.func.isRequired,
  clearDiscountCode: PropTypes.func.isRequired,
  setInputFocus: PropTypes.func.isRequired,
  reloadCheckout: PropTypes.func.isRequired,
  showDiscountCodeInput: PropTypes.func.isRequired,
  setDiscountCode: PropTypes.func.isRequired,
  setSubmitted: PropTypes.func.isRequired,
  submitPaymentToStripe: PropTypes.func.isRequired,
  stripe: PropTypes.object.isRequired,
  successMessage: PropTypes.string.isRequired,
  loadCountryCodes: PropTypes.func.isRequired,
  isStripeLoading: PropTypes.bool.isRequired,
  featureStripe: PropTypes.bool.isRequired,
  hasStoredCard: PropTypes.bool.isRequired,
  storedCard: PropTypes.bool.isRequired,
  clearStoredCard: PropTypes.func.isRequired
};